export default __webpack_public_path__ + "static/media/girlReadingColoured@2x.a0e72def.png";